import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import type { MarketplaceCartPayload } from '@jane/bloom/routes/api.marketplace.cart/types';
import { buildFormData } from '@jane/bloom/utils/formData';
import type { Cart } from '@jane/bloom/viewModels/cart';

export const useMarketplaceCart = () => {
  const marketplaceCartFetcher = useFetcher<Cart>();

  const createCart = useCallback(
    ({ products, reservationMode, storeId }: MarketplaceCartPayload) => {
      marketplaceCartFetcher.submit(
        buildFormData({
          products: JSON.stringify(products),
          reservationMode,
          storeId,
        }),
        {
          action: `/api/marketplace/cart`,
          method: 'post',
        }
      );
    },
    [marketplaceCartFetcher]
  );

  const deleteCart = useCallback(
    ({ cartUuid }: { cartUuid: string }) => {
      marketplaceCartFetcher.submit(
        buildFormData({
          uuid: cartUuid,
        }),
        {
          action: `/api/marketplace/cart`,
          method: 'delete',
        }
      );
    },
    [marketplaceCartFetcher]
  );

  return {
    createCart,
    deleteCart,
    newCart: marketplaceCartFetcher.data,
  };
};
